import { withChildren } from '@builder.io/react';
import { createBuilderModule } from '../../register-builder/builder-module';
import { HeadingLevel } from './HeadingLevel';

export default createBuilderModule(withChildren(HeadingLevel), {
  name: 'HeadingLevel',
  inputs: [],
});
